module.exports = __webpack_public_path__ + "img/美妆-10.a6070755.png";